import { ReactComponent as Save } from "assets/icon_save.svg";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import { fetchmembersInfo } from "components/common/Filters/Filters.slice";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import Spinner from "components/common/Spinner/Spinner";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { CORPORATE_USER, FEEDBACK_TIMER, ManageSuggestionPlansLimit, PAGE_SIZE } from "utils/CommonConstants";
import { recommendationAccessTypes } from "utils/Types";
import { setDialog } from "../Corp/CorpUser.Slice";
import SaveList from "../MyLists/Dialogs/SaveList";
import {
  fetchAllSuggestedInncodesAsync,
  fetchSuggestedByDetailsAsync,
  fetchSuggestionsAsync,
  reset,
  resetPayloadData,
  setAssignmentPopupOpen,
  setIsAllSelected,
  setIsErrorWhenLimitExceed,
  // setSearchText,
  setSelectedSuggestedInncodes
} from "./ManageSuggestions.slice";
import "./index.scss";

import Feedback from "components/common/Feedback";

import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import { useSearchParams } from "react-router-dom";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { setFilters } from "../PlanAssignment/PlanAssignment.slice";
import ManageSuggestionTable from "./ManageSuggestionTable";
import SuggestedPlansModal from "./SuggestedPlans";
import { getHeaders } from "./TableHeadersConfig";
import UploadSuggestions from "./UploadSuggestions";

const ManageSuggestions = () => {
  const [pageNo, setPageNo] = useState(0);
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[filterPage.manageSuggestionsDisplay]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);

  const suggestions = useAppSelector((state) => state.manageSuggestions.suggestions);
  const totalSuggestions = useAppSelector((state) => state.manageSuggestions.totalSuggestions);
  const sorting = useAppSelector((state) => state.sortingDetails.sorting);

  const selectedSuggestedInncodes = useAppSelector((state) => state.manageSuggestions.selectedSuggestedInncodes);
  const isAssignmentPopupOpen = useAppSelector((state) => state.manageSuggestions.isAssignmentPopupOpen);
  const isAllSelected = useAppSelector((state) => state.manageSuggestions.isAllSelected);

  const suggestionsLoader = useAppSelector((state) => state.manageSuggestions.suggestionsLoader);
  const { uploadRecommendationAccess, uploadMetricAccess } = useAppSelector((state) => state.app.loggedInUserDetails);
  const suggestedByDetails = useAppSelector((state) => state.manageSuggestions.suggestedByDetails);
  const { isMobileScreen } = useContext(ThemeContext);
  const recentSortingApplied = sorting?.["manageSuggestions"];
  const isErrorWhenLimitExceed = useAppSelector((state) => state.manageSuggestions?.isErrorWhenLimitExceed);
  const allSuggestedInncodes = useAppSelector((state) => state.manageSuggestions.allSuggestedInncodes);

  const [searchParams] = useSearchParams();

  const searchText = globalFiltersforPage?.searchText;

  const dispatch = useAppDispatch();
  const translate = useTranslate();
  let isError = false;

  const getPayload = (page?: number) => {
    const payload = {
      pageable: {
        page: page ?? pageNo,
        size: PAGE_SIZE
      },
      searchText: searchText,
      sort: {
        ...recentSortingApplied
      },
      ...formattedFilterRequestPayload,
      includeAllSuggestedBy: !(suggestedByDetails?.length > 0)
    };
    return payload;
  };

  useEffect(() => {
    (async () => {
      setPageNo(0);
      let resp;
      if (!isEmpty(filterRequestPayload)) {
        let payload: any = getPayload();
        payload = { ...payload, allSelected: true };
        dispatch(fetchAllSuggestedInncodesAsync(payload));

        if (!isAssignmentPopupOpen) resp = await dispatch(fetchSuggestionsAsync(getPayload(0)));
        if (
          !suggestedByDetails?.length &&
          (resp?.payload?.meta?.hltIds?.length || resp?.payload?.meta?.hltIds === null)
        ) {
          const suggestedByList = resp?.payload?.meta?.hltIds;
          const props = {
            hltIds: suggestedByList,
            size: suggestedByList?.length
          };
          await dispatch(fetchSuggestedByDetailsAsync(props));
        }
      } else {
        dispatch(reset());
      }
    })();
  }, [recentSortingApplied, filterRequestPayload, searchText, isAssignmentPopupOpen]);

  useEffect(() => {
    dispatch(setIsAllSelected(false));
    dispatch(setSelectedSuggestedInncodes([]));
  }, [filterRequestPayload]);

  useEffect(() => {
    if (!selectedSuggestedInncodes?.length) dispatch(setIsErrorWhenLimitExceed(false));
  }, [selectedSuggestedInncodes]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const getPaginatedData = () => {
    dispatch(fetchSuggestionsAsync(getPayload()));
  };

  useEffect(() => {
    if (pageNo > 0) getPaginatedData();
  }, [pageNo]);

  const handleSelectedAllInncodes = (e: any) => {
    let bool: boolean = e.target.checked;
    const allInncodes = allSuggestedInncodes && [...allSuggestedInncodes];
    if (bool) {
      dispatch(setSelectedSuggestedInncodes(allInncodes));
    } else {
      dispatch(setSelectedSuggestedInncodes([]));
    }
    dispatch(setIsAllSelected(!isAllSelected));
  };

  const getMembersList = (searchValue: string) => {
    const props: any = {
      searchText: searchValue,
      userType: CORPORATE_USER,
      page: 0,
      size: 100
    };
    dispatch(fetchmembersInfo(props));
  };

  const handleSuggestedModalClose = () => {
    dispatch(setSelectedSuggestedInncodes([]));
    dispatch(resetPayloadData());
    if (isAllSelected) dispatch(setIsAllSelected(!isAllSelected));
  };

  const suggestedPlansHandle = () => {
    if (selectedSuggestedInncodes?.length > ManageSuggestionPlansLimit) {
      isError = selectedSuggestedInncodes.length > ManageSuggestionPlansLimit;
    } else {
      isError = false;
      dispatch(setAssignmentPopupOpen(true));
      dispatch(setFilters({ searchText: "" }));
    }
    dispatch(setIsErrorWhenLimitExceed(isError));
  };

  const getFiltersUi = () => (
    <GlobalFilters
      searchBarPlaceholder="Search by Inncode"
      isSearchBarVisible
      page={filterPage.manageSuggestionsDisplay}
      getMembersList={getMembersList}
      searchedText={searchText}
      isPreDefinedNav
    />
  );

  return (
    <>
      {isErrorWhenLimitExceed && (
        <Feedback
          form=""
          actionStatus={{ shouldShow: isErrorWhenLimitExceed, variant: "error", timer: FEEDBACK_TIMER }}
          message={translate("common.planAssigmentLimit", {
            PlanAssigmentLimit: ManageSuggestionPlansLimit.toString()
          })}
          onCloseChange={() => dispatch(setIsErrorWhenLimitExceed(false))}
        />
      )}
      {isAssignmentPopupOpen && <SuggestedPlansModal handleClose={handleSuggestedModalClose} />}
      {suggestionsLoader && <Spinner backdropVisible />}
      <div className="manage-suggestions-component">
        <div className="manage-suggestions-container-top">
          <div className="manage-suggestions-left-wrapper">
            <Typography variant={"h3"} showBold color={tokens.Text.General.PrimaryHeadline}>
              {translate("manageSuggestions.header")}{" "}
            </Typography>
          </div>
          {(uploadRecommendationAccess === recommendationAccessTypes.upload || uploadMetricAccess !== "Disabled") && (
            <UploadSuggestions />
          )}
        </div>
        <div className="manage-suggestions-container-bottom">
          <div className="search-filter-wrapper">
            <div className={isMobileScreen ? "isMobileFilters" : ""}>
              <Typography variant={"h4"} showBold color={tokens.Text.General.PrimaryHeadline}>
                {translate("manageSuggestions.inncodeList")}{" "}
              </Typography>
            </div>
            <div>{!isMobileScreen && getFiltersUi()}</div>
            <div> {isMobileScreen && getFiltersUi()}</div>
          </div>
          <div>
            <GlobalFilterDescription page={filterPage.manageSuggestionsDisplay} />
          </div>
          {Object.keys(filterRequestPayload).length !== 0 && (
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              {" "}
              <Typography
                onClick={() => dispatch(setDialog({ dialogName: "saveList", isOpen: true, data: [] }))}
                sx={{ cursor: "pointer", display: "flex", marginLeft: "auto", alignItems: "center", gap: "5px" }}
                variant="body2"
              >
                <Save /> Save to My Lists
              </Typography>
            </div>
          )}
          <div className="manage-suggestions-table" id="manage-suggestions-table">
            <BasicTable
              pagination={{ pageNo, setPageNo }}
              totalRecords={totalSuggestions}
              scrollableTarget="manage-suggestions-table"
              tableName="manageSuggestions"
              noDataMessage={
                isEmpty(filterRequestPayload) ? "Please use the filters panel to show any results" : "No Results"
              }
              selectAllProperties={isAllSelected}
              handleSelectedAll={(e: any) => handleSelectedAllInncodes(e)}
              innerTable={(args: any) => <ManageSuggestionTable {...args} />}
              data={{
                view: "manageSuggestions",
                headers: getHeaders(
                  uploadRecommendationAccess === recommendationAccessTypes.edit ||
                    uploadRecommendationAccess === recommendationAccessTypes.upload
                ),
                rows: suggestions
              }}
            />
          </div>
          {selectedSuggestedInncodes?.length > 0 && (
            <div className="suggested-button">
              <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} textAlign={"center"}>
                {selectedSuggestedInncodes.length} {selectedSuggestedInncodes.length > 1 ? "Inncodes" : "Inncode"}{" "}
                selected
              </Typography>
              <Button
                className="button"
                label="Add Suggested Plan(s)"
                variant="outlined"
                onClick={suggestedPlansHandle}
              />
            </div>
          )}
        </div>
      </div>
      <SaveList />
    </>
  );
};
export default ManageSuggestions;
